<template>
  <div class="userService">
    <div class="header">隐私政策</div>
    <div class="serviceWrap" v-for="(item, index) in serviceList " :key="index">
      <div class="serviceWrap_title">{{ item.title }}</div>
      <div class="serviceWrap_con" v-if='item.id == 1'>
        1.1网站将通过您的ip地址来收集非个人化的信息，例如您的浏览器性质、操作系统种类、给您提供接入服务的isp的域名等，以优化在您计算机屏幕上显示的页面。通过收集上述信息，我们亦进行客流量统计。<br>
        1.2这些无关个人身份的信息能帮助我们辩别网站最受欢迎的地区并确定我们推广活动的有效性。此外，我们也可能将这些信息披露给我们的广告客户，使他们知道点击他们广告的人数。
      </div>
      <div class="serviceWrap_con" v-if='item.id == 2'>
      2.1当您在网站进行用户注册登记、网上咨询、公共论坛等活动时，在您的同意及确认下，本网站将通过注册表格、提问表格等形式要求您提供一些个人资料。这些个人资料包括：<br/>
      （1）个人识别资料：如姓名、性别、年龄、出生日期、身份证号码（或护照号码）、电话、通信地址、住址、电子邮件地址等。<br/>
       （2）个人背景：职业、教育程度、收入状况、婚姻、家庭状况。<br/>
        2.2请了解，在未经您同意及确认之前，本网站不会将您为参加本网站之特定活动所提供的资料利用于其它目的。惟按规定应政府及法律要求披露时不在此限。<br/>
         2.3网站收集这类关于个人身份的信息主要是为了其用户能够更容易和更满意地使用网站的健康服务。我们的目标是向所有的用户提供便利的、满意的的健康服务。而这些个人信息有助于我们实现这一目标。<br/>
         2.4所有的用户和访问者应该知道，当他们在网站社区、网站、网站医生研究室或其他网上公开场合披露其个人身份信息，该等信息可能会被他人收集并用来向他们发送未经邀约的电子邮件。 <br/>
      </div>
      <div class="serviceWrap_con" v-if='item.id == 3'>
      3.1本网站将对您所提供的资料进行严格的管理及保护，本网站将使用相应的技术，防止您的个人资料丢失、被盗用或遭篡改。<br/> 
      3.2本网站在必要时委托专业技术人员代为对该类资料进行电脑处理，以符合专业分工之要求。如本网站将电脑处理之通知送达予您，而您未在通知规定的时间内主动明示反对，本网站将推定您已同意。惟在其后您仍然有权，请求停止电脑处理。<br/> 
      
      </div>
      <div class="serviceWrap_con" v-if='item.id == 4'>
        4.1您对于自己的个人资料享有以下权利：<br/> 
      （1）随时查询及请求阅览；<br/> 
      （2）随时请求补充或更正；<br/> 
      （3）请求停止电脑处理及利用。<br/> 
     4.2网站为其用户提供的各项活动或调查，为了确认用户身份，我们通常要求申请者在联系方法(通讯地址和电话)之外，还要求用户填写健康情况等资料。此类信息被网站用来累积其用户的数据。如果用户不想提供所要求的信息和参加活动，这完全是用户的决定。 <br/> 
     4.3用户是唯一对自己的密码、支付密码及其他帐户信息负有保密责任的人。当你在线时，请小心和负责。 <br/> 
      
      </div>
      <div class="serviceWrap_con" v-if='item.id == 5'>
        本网站惟在符合下列条件之一，方对收集之个人资料进行必要范围以外之利用：<br/> 
      5.1已取得您的同意；<br/> 
      5.2为免除您在生命、身体或财产方面之急迫危险；<br/> 
      5.3为防止他人权益之重大危害；<br/> 
      5.4为增进公共利益，且无害于您的重大利益。<br/> 
    
      </div>
      <div class="serviceWrap_con" v-if='item.id == 6'>
         当政府机关依照法定程序要求本网站披露个人资料时，本网站将根据执法单位之要求或为公共安全之目的提供个人资料。在此情况下之任何披露，本网站均得免责。<br/> 
      
      </div>
      <div class="serviceWrap_con" v-if='item.id == 7'>
     7.1本网站将建立和维持一合理的程序，以保护未成年人个人资料的保密性及安全性。本网站郑重声明：任何16岁以下的未成年人参加网上活动应事先得到家长或其法定监护人（以下统称为"监护人"）的可经查证的同意。 <br/> 
     7.2监护人应承担保护未成年人在网络环境下的隐私权的首要责任。 <br/> 
       7.3监护人有权拒绝本网站与其子女或被监护人做进一步的联络。 <br/> 
     7.4本网站收集未成年人的个人资料，这些资料只是单纯作为保护未成年人参与网络活动时的安全，而非作为其它目的之利用。本网站保证不会要求未成年人提供额外的个人资料，以作为允许其参与网上活动的条件。
  <br/> 
      
      </div>
      <div class="serviceWrap_con" v-if='item.id == 8'>
       8．任何单位或个人认为网站的内容可能涉嫌侵犯其合法权益，应该及时向网站书面反馈，并提供身份证明、权属证明及详细侵权情况证明，在收到上述法律文件后，网站将会尽快移除被控侵权内容。
      </div>
      <div class="serviceWrap_con" v-if='item.id == 9'>
     9.1由于您将用户密码或支付密码告知他人或与他人共享注册帐户，由此导致的任何个人资料泄露。 <br/> 
      9.2任何由于计算机问题、黑客政击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人资料泄露、丢失、被盗用或被窜改等。 <br/> 
      9.3由于与本网站链接的其它网站所造成之个人资料泄露及由此而导致的任何法律争议和后果。在向这些与网站链接的网站提供个人信息之前，请查阅它们的隐私政策。<br/> 
      9.4本网站之保护隐私声明的修改及更新权均属于网站。<br/> 
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
let serviceList = ref([
  { title: '1．非个人信息', id: 1 }, { title: '2．个人资料', id: 2 }, { title: '3．信息安全', id: 3 }, { title: '4．用户权利', id: 4 }, { title: '5．限制利用原则：', id: 5 }, { title: '6．个人资料之披露：', id: 6 }, { title: '7．未成年人资料的保护', id: 7 }, { title: '', id: 8 }, { title: '9．免责：除上述之规定属免责外，下列情况时本网站亦毋需承担任何责任：', id: 9 }
])

</script>

<style lang="scss" scoped>
.userService {
  .header {
    font-size: 28px;
    
    color: #333333;
    line-height: 40px;
  }

  .con {
    font-size: 18px;
    font-weight: 400;font-weight: lighter;
    color: #333333;
    line-height: 36px;
    margin-top: 30px;
  }

  .serviceWrap {
    &_title {
      // background-color: rgb(255, 127, 170);
      font-size: 22px;
      
      color: #333333;
      line-height: 30px;
      margin: 30px 0 20px;
    }

    &_con {
      font-size: 18px;
      font-weight: 400;font-weight: lighter;
      color: #333333;
      line-height: 36px;
    }

    &_con1 {
      font-size: 16px;
    }
  }

}
</style>